module.exports = __webpack_public_path__ + "static/media/tutorial6.7a6cf872.png";